import {gql} from '@apollo/client'

const EMAIL_SETUP_FIELDS = `
  emailMode
  emailHost
  emailPort
  emailHostUser
  emailUseTls
  defaultFromEmail
  hasEmailHostPassword
`

export const GET_SYSTEM_EMAIL_SETTINGS = gql`
  query getSystemEmailSettings {
    systemEmailSettings {
      id
      senderName
      senderEmail
      signatureHtml
      isSystemDefault
      publicRequireIdentity
      ${EMAIL_SETUP_FIELDS}
    }
  }
`

export const GET_ORGANIZATION_EMAIL_SETTINGS = gql`
  query getOrganizationEmailSettings($organizationId: ID!) {
    organizationEmailSettings(organizationId: $organizationId) {
      id
      senderName
      senderEmail
      signatureHtml
      ${EMAIL_SETUP_FIELDS}
    }
  }
`

export const GET_USER_EMAIL_SETTINGS = gql`
  query getUserEmailSettings($userId: ID!) {
    userEmailSettings(userId: $userId) {
      id
      senderName
      senderEmail
      signatureHtml
    }
  }
`

export const GET_RESOLVED_EMAIL_SETTINGS = gql`
  query getResolvedEmailSettings($userId: ID, $organizationId: ID) {
    resolvedEmailSettings(userId: $userId, organizationId: $organizationId) {
      senderName
      senderEmail
      signatureHtml
      ${EMAIL_SETUP_FIELDS}
      sources {
        senderName
        senderEmail
        signatureHtml
        emailMode
        emailHost
        emailPort
        emailHostUser
        emailUseTls
        defaultFromEmail
      }
    }
  }
`
